import { PayloadAction } from '@reduxjs/toolkit';
import {
  IClassRoomDataDetail, IClassRoomInstructor,
} from '@/store/types';
import { GetClassRoomDataProps } from '@/fetches/user/class-room/get-class-room';
import { createSliceSteamup } from '../common';

interface IClassRoomsState {
  loading: boolean;
  // list: IClassRoomData[];
  list: GetClassRoomDataProps[];
  keywordList: number[];
  filter: {
    keyword: number[];
    // q: string; // q 대신 search 사용중이라 일단 주석처리해둠
    search: string;
  }
  currentPage: string;
}

export const initialClassroomState: IClassRoomDataDetail = {
  uuid: '',
  creatorUUID: '',
  creatorAvatarUrl: '',
  creatorName: '',
  createdAt: new Date(),
  updatedAt: new Date(),
  postedAt: new Date(),
  expiredAt: 0,
  title: '',
  subTitle: '',
  content: '',
  thumbnail: {
    main: '',
    images: [],
  },
  isPurchased: false,
  purchasedCreatedAt: new Date(),
  purchasedExpiredAt: 0,
  inviteCode: '',
  subject: [],
  grade: [],
  level: 0,
  price: 0,
  keywords: [],
  rating: 0,
  viewCnt: 0,
  userCnt: 0,
  isBookmark: false,
  progress: 0,
  isPost: false,
};

export const initCreatorState: IClassRoomInstructor = {
  uuid: '',
  avatarURL: '',
  name: '',
  shortIntroduction: '',
  belong: '',
  postsCnt: 0,
  followerCnt: 0,
  reviewCnt: 0,
  hasFollow: false,
};

const classRoomsSlice = createSliceSteamup(
  'classRooms',
  {
    loading: true,
    list: [],
    keywordList: [],
    filter: {
      keyword: [],
      // q: '',
      search: '',
    },

    currentPage: '',
  } as IClassRoomsState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setKeywordListInit(state, { payload }: PayloadAction<(typeof state.keywordList)>) {
      state.keywordList = payload;
    },
    setQ(state, { payload }: PayloadAction<(typeof state.filter.search)>) { // setKeyword => setQ
      state.filter.search = payload;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.keyword)>) {
      state.filter.keyword = payload;
    },
    setRemoveKeyword(state) {
      state.filter.search = '';
    },
    setReset(state) {
      state.filter.search = '';
      state.filter.keyword = [];
    },
    pushFilterOfTag(state, { payload }: PayloadAction<number>) {
      state.filter.keyword.push(payload);
    },
    setFilterOfTag(state, { payload }: PayloadAction<{ keyIDs: number[] }>) {
      state.filter.keyword = payload.keyIDs;
    },
    setRemoveTag(state, { payload }: PayloadAction<number>) {
      state.filter.keyword = state.filter.keyword.filter((id) => id !== payload);
    },
  },
);

export default classRoomsSlice;
